import { render } from "./company-details-modal.vue?vue&type=template&id=52791f29"
import script from "./company-details-modal.vue?vue&type=script&lang=js"
export * from "./company-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__